<template>
  <div class="home">
    <div class="container course-container">
      <h1 class="title is-2">Kurser</h1>
      <span v-html="frontText"></span>

      <course-list-public @courseSelected="courseSelected">
      </course-list-public>
      <book-course
        :course="selectedCourse"
        @closeBooking="closeBooking"
      ></book-course>
    </div>
    <!-- {{courses}} -->
  </div>
</template>

<script>
import CourseListPublic from "@/components/Public/CourseListPublic.vue";
import BookCourse from "@/components/Public/BookCourse.vue";
import router from "@/router.js";
import axios from "@/utils/request.js";

export default {
  name: "book",
  components: {
    CourseListPublic,
    BookCourse,
  },
  data: function () {
    return {
      selectedCourse: null,
      frontText: ""
    };
  },
  methods: {
    closeBooking: function () {
      router.push("book");
      this.selectedCourse = null;
    },
    courseSelected: function (course) {
      this.selectedCourse = course;
    },
    getFrontText: function(){
      axios.get("/api/texts/front").then((response) => {
        this.frontText = response.data
      })
    }
  },
  created() {
    this.getFrontText()
  },
};
</script>

<style scoped>
.course-container {
  text-align: left;
  padding: 15px;
}

.month {
  margin-bottom: 20px;
}

.nbr {
  margin-left: auto;
}

.list {
  box-shadow: none !important;
}
</style>